export default __webpack_public_path__ + "static/media/ivisit-new-logo-1.44a3501a.svg";